import React, { useState, useEffect } from "react";
import styles from "./ModalQuestionariosComponent.module.css";
import {
  Input,
  InputGroup,
  InputGroupText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table
} from "reactstrap";
import api from '../../service/api';
import { AiOutlineSearch, AiOutlineArrowRight } from 'react-icons/ai';
import ModalComponent from '../../components/Modal/ModalComponent';

export default function ModalQuestionariosComponent({
  isOpen,
  onClose,
  vida,
  telefone
}) {
  const [isSent, setIsSent] = useState(false);
  const [questionarios, setQuestionarios] = useState([]);
  const [filtrados, setFiltrados] = useState([]);
  const [busca, setBusca] = useState("");

  // sempre que abrir, resetar "enviado" e carregar lista
  useEffect(() => {
    if (!isOpen) return;
    setIsSent(false);
    api.get('questionarios').then(({ data }) => {
      setQuestionarios(
        data.sort((a, b) => a.nome.localeCompare(b.nome))
      );
    });
  }, [isOpen]);

  // filtrar conforme busca
  useEffect(() => {
    const lower = busca.toLowerCase();
    setFiltrados(
      questionarios.filter(q =>
        q.nome.toLowerCase().includes(lower)
      )
    );
  }, [busca, questionarios]);

  const enviarQuestionario = (questionarioId) => {
    api.post('envioQuestionario', {
      idVida: vida,
      questionario: questionarioId
    }).then(({ data }) => {
      const url =
        "https://api.whatsapp.com/send?phone=55" +
        parseInt(telefone.replace(/\D/g, "")) +
        "&text=Link para responder o questionário " +
        process.env.REACT_APP_FRONT_URL +
        "perguntas/" +
        data.linkCript;
      window.open(url);
      setIsSent(true);
    });
  };

  return (
    <div>
      <ModalComponent
        isOpen={isSent}
        onClose={() => setIsSent(false)}
        mensagem="Questionário enviado com sucesso!"
        icon="SucessoEnvioQuestionario"
      />

      <Modal centered isOpen={isOpen}>
        <ModalHeader>Escolha um Questionário</ModalHeader>
        <ModalBody>
          <InputGroup>
            <Input
              size="sm"
              placeholder="Busque pelo nome"
              className={styles.inputBusca}
              value={busca}
              onChange={e => setBusca(e.target.value)}
            />
            <InputGroupText className={styles.textBuscar}>
              <AiOutlineSearch size={17} className={styles.iconBuscar} />
              Buscar
            </InputGroupText>
          </InputGroup>

          <Table size="sm" striped className={styles.table}>
            <thead>
              <tr>
                <th>Questionário</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {(busca ? filtrados : questionarios).map(q => (
                <tr key={q.id}>
                  <td className={styles.tbody}>{q.nome}</td>
                  <td>
                    <Button
                      size="sm"
                      className={styles.buttonFormulario}
                      onClick={() => enviarQuestionario(q.id)}
                    >
                      <AiOutlineArrowRight size={17} className={styles.buttonIcon} />
                      Enviar
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" onClick={onClose} className={styles.button}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
